/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { func, object } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import MarkdownText from './MarkdownText';
import StyledButton from '../../../../../EnterpriseDesignSystem/Button/StyledButton';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { emitCustomTrackingEvent } from '../../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import { setOfferInboxShowBonusOffer } from '../../../../../../../state/ducks/App/App-Actions';
import { getPageType } from '../../../../../../../state/ducks/App/App-Selectors';
import noop from '../../../../../../helpers/noop';

const useStyles = makeStyles((theme) => ({
    container: (styles) => ({
        marginTop: '20px',
        borderTop: styles?.backgroundColor ? '' : '1px solid #D9D9D9',
        backgroundColor: styles?.backgroundColor,
        padding: '1px 16px 12px',
    }),
}));

const BonusBanner = ({ data, setLabelState }) => {
    const classes = useStyles({
        backgroundColor: data?.background_color?.color,
    });
    const dispatch = useDispatch();
    const pageType = useSelector(getPageType);
    const headingText = data?.text?.[0];
    const descriptionText = data?.text?.[1];

    const handleClick = (e) => {
        const {
            tracking_event_category,
            tracking_event_action,
            tracking_event_label,
        } = data?.button?.tracking || {};

        dispatch(trackEvent({
            eventCategory: tracking_event_category || '',
            eventAction: tracking_event_action || '',
            eventLabel: tracking_event_label || '',
        }));

        dispatch(emitCustomTrackingEvent({
            action: 'Click',
            eventSubType: 'feature-tracking',
            page: { type: pageType },
            label: 'offer-inbox-bonus-offer',
        }));

        dispatch(setOfferInboxShowBonusOffer(true));

        setLabelState('success');
    };

    return (
        <div className={classes.container}>
            {headingText && (
                <MarkdownText
                    data={headingText}
                />
            )}
            {data?.button?.link?.title && (
                <StyledButton
                    link={data?.button?.link?.href || '#'}
                    label={data?.button?.link?.title}
                    variant={data?.button?.variant}
                    size={data?.button?.size}
                    fullWidth={data?.button?.full_width}
                    disabled={data?.button?.disabled}
                    type={data?.button?.type}
                    icon={data?.icon || {}}
                    handleOnClick={handleClick}
                />
            )}
            {descriptionText && (
                <MarkdownText
                    data={descriptionText}
                />
            )}
        </div>
    );
};

BonusBanner.propTypes = {
    data: object,
    setLabelState: func,
};

BonusBanner.defaultProps = {
    data: {},
    setLabelState: noop,
};

export default BonusBanner;
